import { ref } from 'vue';
import { v4 as uuidv4 } from 'uuid';

export default function useTokenManager() {
    const token = ref(localStorage.getItem('token') || '');

    function setToken(newToken) {
        token.value = newToken;
        localStorage.setItem('token', newToken);
    }

    function hasToken() {
        return !!token.value;
    }

    function removeToken() {
        token.value = '';
        localStorage.removeItem('token');
    }

    function initialize() {
        if (!hasToken()) {
            setToken(generateUniqueToken());
        }
    }

    function generateUniqueToken() {
        return uuidv4();
    }

    // Initialization on load
    initialize();

    return {
        token,
        setToken,
        hasToken,
        removeToken,
        initialize,
        generateUniqueToken
    };
}
